import { render } from "./QuranProgramsSchedules.vue?vue&type=template&id=aaac21f4&scoped=true"
const script = {}

import "./QuranProgramsSchedules.vue?vue&type=style&index=0&id=aaac21f4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aaac21f4"]])

export default __exports__